module.exports = __webpack_public_path__ + "static/media/DG8960-ben2.429e7005.png";